import React, { useState, useEffect, useContext } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { List, Avatar, Divider, Skeleton } from 'antd';
import { getAllConversations } from 'api-services/conversations';
import PerfectScrollbar from 'react-perfect-scrollbar';
import BotChatImg from 'assets/img/AvatarPlaceholder.svg';
import ChatBotContext from 'hooks/chat-bot-context';
import Helper from 'utilities/helper';
import { useNavigate } from 'react-router';

const ConversationList = ({ handleClick }) => {
  const navigate = useNavigate();
  const { selectedBot } = useContext(ChatBotContext);
  const [data, setData] = useState([]);
  const [listCount, setListCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [skeleton, setSkeleton] = useState(true);

  const loadMoreData = async (offset = 0) => {
    try {
      setSkeleton(true);
      // Send API request and receive response
      const response = await getAllConversations(selectedBot, offset);
      if (response?.data) {
        setData([...data, ...(response?.data?.data || [])]);
        setTotalCount(totalCount + response.data.data.length);
        setListCount(response?.data?.total_count);
        //setLoading(false);
      } else {
        // Handle error if the API request is unsuccessful
        //setLoading(false);
        console.error('API request failed:', response.status, response.statusText);
      }
    } catch (error) {
      // Handle error if the API request encounters an exception
      console.error('API request error:', error);
      //setLoading(false);
    } finally{
      setSkeleton(false);
    }
  };

  useEffect(() => {
    if(selectedBot)
      loadMoreData();
    else 
      navigate('/chatbots');
  }, [selectedBot]);

  return (
    <PerfectScrollbar id='scrollableDiv' className='conversation-scroll-container'>
      {skeleton && <Skeleton active />}
      {!skeleton && <InfiniteScroll
        dataLength={data.length}
        next={() => loadMoreData(data.length)}
        hasMore={totalCount < listCount}
        loader={
          <Skeleton
            avatar
            paragraph={{
              rows: 1,
            }}
            active
          />
        }
        endMessage={<Divider plain>No more converations.</Divider>}
        scrollableTarget='scrollableDiv'>
        <List
          dataSource={data}
          renderItem={(item) => (
            <List.Item key={item.email} onClick={() => handleClick(item)}>
              <List.Item.Meta avatar={<Avatar src={BotChatImg} />} description={
                <div>
                  {item?.name && <p><b>{item?.name}</b> {item?.email && `(${item?.email})`}</p>}
                  <p>{Helper.convertServerDate(item?.conversation_timestamp)}</p>
                </div>} />
            </List.Item>
          )}
        />
      </InfiniteScroll>}
    </PerfectScrollbar>
  );
};

export default ConversationList;
